import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./components/navbar/NavigationBar";
import LandingPage from "./pages/public/LandingPage/LandingPage";
import Support from "./pages/public/Support/Support";
import HowToPlay from "./pages/public/Play/Play";
import News from "./pages/public/News/News";
import Info from "./pages/public/Info/Info";
import Roadmap from "./pages/public/Roadmap/Roadmap";
import CreateAccount from "./pages/public/createAccount/createAccount";
import RevivalJourney from "./pages/public/revivaljourney/revivaljourney";
import MissingPage from "./pages/public/MissingPage/MissingPage";
import Leaderboard from "./pages/public/Leaderboard/Leaderboard";
import Newsarticle from "./pages/public/NewsArticle/newsarticle";
import LeaderboardOverall from "./pages/public/Leaderboard/categories/Overall";
import LeaderboardSupport from "./pages/public/Leaderboard/categories/Support";
import LeaderboardTactical from "./pages/public/Leaderboard/categories/Tactical";
import LeaderboardWeapons from "./pages/public/Leaderboard/categories/Weapons";
import LeaderboardVehicle from "./pages/public/Leaderboard/categories/Vehicles";
import LeaderboardAssaultTeam from "./pages/public/Leaderboard/categories/AssaultTeams";
import ComponentViewer from "./pages/public/ComponentViewer/ComponentViewer";
import TestingApplication from "./pages/public/testingApplication/TestingApplication";

export const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} exact />
        <Route path="*" element={<MissingPage />} />
        <Route path="/Roadmap" element={<Roadmap />} exact />
        <Route path="/Play" element={<HowToPlay />} exact />
        <Route path="/Info" element={<Info />} exact />
        <Route path="/Support" element={<Support />} exact />
        <Route path="/News" element={<News />} exact />
        <Route path="/Newsarticle" element={<Newsarticle />} exact />
        <Route path="/createAccount" element={<CreateAccount />} exact />
        <Route path="/RevivalJourney" element={<RevivalJourney />} exact />
        <Route path="/leaderboard" element={<Leaderboard />} exact />
        <Route path="/TestingApplication" element={<TestingApplication />} exact />
        <Route path="/leaderboard-overall" element={<LeaderboardOverall />} exact />
        <Route path="/leaderboard-tactical" element={<LeaderboardTactical />} exact />
        <Route path="/leaderboard-support" element={<LeaderboardSupport />} exact />
        <Route path="/leaderboard-weapons" element={<LeaderboardWeapons />} exact />
        <Route path="/leaderboard-vehicles" element={<LeaderboardVehicle />} exact />
        <Route path="/leaderboard-assaultteams" element={<LeaderboardAssaultTeam />} exact />
        <Route path="/componentviewer" element={<ComponentViewer />} exact />
      </Routes>
    </Router>
  );
};

export default App;
